import React from 'react';
import RoomBookingStepperDialog from './RoomBookingStepperDialog';
import { RoomSummary } from '../models/Room';

interface RoomBookingDialogProps {
  open: boolean;
  onClose: () => void;
  room: RoomSummary;
  spaceName?: string;
  initialDateTime?: Date;
  initialDuration?: number;
  initialStepKey?: 'timeAndDate' | 'additionalGear' | 'paymentOptions' | 'whoIsComing' | 'pay' | 'confirmation' | null;
}

export default function RoomBookingDialog({
  open,
  onClose,
  room,
  spaceName,
  initialDateTime,
  initialDuration,
  initialStepKey,
}: RoomBookingDialogProps) {
  return (
    <RoomBookingStepperDialog
      open={open}
      onClose={onClose}
      room={room}
      spaceName={spaceName}
      initialDateTime={initialDateTime}
      initialDuration={initialDuration}
      initialStepKey={initialStepKey}
    />
  );
}


